"use strict";
// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
Object.defineProperty(exports, "__esModule", { value: true });
exports.uploadData = uploadData;
const core_1 = require("@aws-amplify/core");
const uploadData_1 = require("./internal/uploadData");
function uploadData(input) {
    return (0, uploadData_1.uploadData)(core_1.Amplify, {
        ...input,
        options: {
            ...input?.options,
            // This option enables caching in-progress multipart uploads.
            // It's ONLY needed for client-side API.
            resumableUploadsCache: core_1.defaultStorage,
        },
    });
}
